import {
  ContractEstimatesCompactCard,
  ContractEstimatesDetails,
} from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedAuctionListingDetails,
  type OrchestratedOfferingListingDetails,
  type OrchestratedQuote,
} from '@b-stock/fe-core/bstock-next/queries'

import { ShippingQuote } from '@/buyer-portal/components/features/listing/ListingActionColumn/ContractEstimates/ShippingQuote'
import { Card } from '@/buyer-portal/components/layouts/CardLayout/card/ui'

type ContractEstimatesListing =
  | OrchestratedAuctionListingDetails
  | OrchestratedOfferingListingDetails

export const ContractEstimates = ({
  listing,
  selectedQuote,
  showQuoteInformation,
}: {
  listing: ContractEstimatesListing
  selectedQuote?: OrchestratedQuote | null
  showQuoteInformation: boolean
}) => {
  const { contract } = listing

  if (!contract) return null

  const { estimatedInventoryPerContract, estimatedInventoryPerOrder } = contract

  const contractEstimatesDetailsHasContent =
    estimatedInventoryPerContract || estimatedInventoryPerOrder

  // Don't render an empty card
  if (!showQuoteInformation && !contractEstimatesDetailsHasContent) {
    return null
  }

  return (
    <Card>
      <ContractEstimatesCompactCard>
        {showQuoteInformation && (
          <ShippingQuote
            selectedQuote={selectedQuote}
            showQuoteInformation={showQuoteInformation}
            currency={listing.currency ?? 'USD'}
          />
        )}
        <ContractEstimatesDetails
          compact
          contract={listing.contract}
          currency={listing.currency ?? 'USD'}
        />
      </ContractEstimatesCompactCard>
    </Card>
  )
}
